import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '~/ducks/authentication/actions';
import { useLogoutMutation } from '~/domain/auth/api/oidc-auth-api';
import useAuthenticationState from '~/ducks/authentication/use-authentication-state';
import paths from '~/app/paths/paths';
import SplashScreen from '~/components/views/SplashScreen/SplashScreen';
import { useLoginUrl } from '~/domain/auth/hooks/use-login-url';
import { redirectUser } from '~/ducks/router/actions';
import { useWebviewAuth } from '~/domain/native/hooks/use-webview-auth';
import { logoutStatusSelector } from '~/sagas/authentication-sagas';
import { LogoutStatus } from '~/domain/auth/models/LogoutStatus';

export const LogoutContainer = () => {
  const dispatch = useDispatch();
  const { mauiLogout } = useWebviewAuth();
  const authentication = useAuthenticationState();
  const { getLogoutUrl } = useLoginUrl();
  const [logout] = useLogoutMutation();
  const logoutStatus = useSelector(logoutStatusSelector);
  const providerRef = useRef(authentication?.provider);

  useEffect(() => {
    const performLogout = async () => {
      providerRef.current = authentication?.provider;
      try {
        await logout().unwrap();
        mauiLogout();
      } catch {}
      dispatch(logoutUser());
    };

    if (authentication?.authenticated) {
      void performLogout();
    } else if (logoutStatus === LogoutStatus.Idle) {
      dispatch(redirectUser({ path: paths.login.path, pushToHistory: false }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, logout, authentication?.authenticated, mauiLogout]);

  useEffect(() => {
    if (logoutStatus !== LogoutStatus.Done) {
      return;
    }

    const redirect = async () => {
      if (providerRef.current === 'isam') {
        dispatch(redirectUser({ path: paths.login.path, pushToHistory: false }));
      } else {
        try {
          const logoutUrl = await getLogoutUrl();
          globalThis.location.replace(logoutUrl);
        } catch {
          dispatch(redirectUser({ path: paths.login.path, pushToHistory: false }));
        }
      }
    };

    void redirect();
  }, [logoutStatus, getLogoutUrl, dispatch]);

  return <SplashScreen />;
};

export default LogoutContainer;
